import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { consumeReturnPath } from "./login";

export default function BasePage() {
  const [scrapeFunction, setScrapeFunction] = useState(null);
  const [openToWorkFunction, setOpenToWorkFunction] = useState(null);
  const navigate = useNavigate();

  // Efter inloggning skickar backend till "/"; gå tillbaka till sidan man var på
  useEffect(() => {
    const returnPath = consumeReturnPath();
    if (returnPath && returnPath !== window.location.pathname + window.location.search + window.location.hash) {
      navigate(returnPath, { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <Navbar onScrape={scrapeFunction} onOpenToWork={openToWorkFunction} />
      <Outlet context={{ setScrapeFunction, setOpenToWorkFunction }} />
    </>
  );
}
